<template>
  <div>
    <div class="view_mode">
      Readonly mode
      <label class="custom-toggle" style="vertical-align: -7px;">
        <input type="checkbox" v-model="isReadOnly" />
        <span
          class="custom-toggle-slider rounded-circle"
          data-label-off="No"
          data-label-on="Yes"
        />
      </label>
      <h1>{{ options.title }}</h1>
    </div>
    <div class="row filesControl" v-show="!isReadOnly">
      <div class="col-md-12">
        <div class="editor">
          <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
            <div class="menubar">
              <span class="menubar__button" :class="{ 'is-active': isActive.bold() }" @click="commands.bold">
                <icon name="bold" />
              </span>
              <span class="menubar__button" :class="{ 'is-active': isActive.italic() }" @click="commands.italic">
                <icon name="italic" />
              </span>
              <span class="menubar__button" :class="{ 'is-active': isActive.strike() }" @click="commands.strike">
                <icon name="strike" />
              </span>
              <span class="menubar__button" :class="{ 'is-active': isActive.underline() }" @click="commands.underline">
                <icon name="underline" />
              </span>
              <span class="menubar__button" :class="{ 'is-active': isActive.code() }" @click="commands.code">
                <icon name="code" />
              </span>
              <span class="menubar__button" :class="{ 'is-active': isActive.paragraph() }" @click="commands.paragraph">
                <icon name="paragraph" />
              </span>
              <span class="menubar__button" :class="{ 'is-active': isActive.heading({ level: 1 }) }" @click="commands.heading({ level: 1 })">
                H1
              </span>
              <span class="menubar__button" :class="{ 'is-active': isActive.heading({ level: 2 }) }" @click="commands.heading({ level: 2 })">
                H2
              </span>
              <span class="menubar__button" :class="{ 'is-active': isActive.heading({ level: 3 }) }" @click="commands.heading({ level: 3 })">
                H3
              </span>
              <span class="menubar__button" :class="{ 'is-active': isActive.bullet_list() }" @click="commands.bullet_list">
                <icon name="ul" />
              </span>
              <span class="menubar__button" :class="{ 'is-active': isActive.ordered_list() }" @click="commands.ordered_list">
                <icon name="ol" />
              </span>
              <span class="menubar__button" :class="{ 'is-active': isActive.blockquote() }" @click="commands.blockquote">
                <icon name="quote" />
              </span>
              <span class="menubar__button" :class="{ 'is-active': isActive.code_block() }" @click="commands.code_block">
                <icon name="code" />
              </span>
              <span class="menubar__button" @click="commands.horizontal_rule">
                <icon name="hr" />
              </span>
              <span class="menubar__button" @click="commands.undo">
                <icon name="undo" />
              </span>
              <span class="menubar__button" @click="commands.redo">
                <icon name="redo" />
              </span>
              <span
                class="menubar__button"
                @click="commands.createTable({rowsCount: 3, colsCount: 3, withHeaderRow: false })"
              >
                <icon name="table" />
              </span>
              <span v-if="isActive.table()">
                <span
                  class="menubar__button"
                  @click="commands.deleteTable"
                >
                  <icon name="delete_table" />
                </span>
                <span
                  class="menubar__button"
                  @click="commands.addColumnBefore"
                >
                  <icon name="add_col_before" />
                </span>
                <span
                  class="menubar__button"
                  @click="commands.addColumnAfter"
                >
                  <icon name="add_col_after" />
                </span>
                <span
                  class="menubar__button"
                  @click="commands.deleteColumn"
                >
                  <icon name="delete_col" />
                </span>
                <span
                  class="menubar__button"
                  @click="commands.addRowBefore"
                >
                  <icon name="add_row_before" />
                </span>
                <span
                  class="menubar__button"
                  @click="commands.addRowAfter"
                >
                  <icon name="add_row_after" />
                </span>
                <span
                  class="menubar__button"
                  @click="commands.deleteRow"
                >
                  <icon name="delete_row" />
                </span>
                <span
                  class="menubar__button"
                  @click="commands.toggleCellMerge"
                >
                  <icon name="combine_cells" />
                </span>
              </span>
            </div>
          </editor-menu-bar>
          <editor-content class="editor__content" :editor="editor" onUpdate="onChange" />
        </div>

        <b-button @click="save" variant="success" class="mt-4">Save</b-button>
      </div>
    </div>
    <div v-show="isReadOnly" class="view_mode">
      <DynamicRender
          :template="options.dataSource || ''"
        />
    </div>
  </div>
</template>

<script>
import Icon from '../DataGrid/form-builder-extension/text_editor/GUITextEditorIcon'
import DynamicRender from '@/components/DynamicRender'
import db from '@/services/db'
import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  Mention,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Table,
  TableHeader,
  TableCell,
  TableRow,
  Strike,
  Underline,
  History,
} from 'tiptap-extensions'
export default {
  components: {
    Icon,
    EditorContent,
    EditorMenuBar,
    DynamicRender,
  },
  props: ["control", 'editorId'],
  data() {
    return {
      isReadOnly: false,
      options: '',
      viewHTML: '',
      editor: new Editor({
        extensions: [
          new Blockquote(),
          new BulletList(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new HorizontalRule(),
          new ListItem(),
          new OrderedList(),
          new TodoItem(),
          new TodoList(),
          new Link(),
          new Bold(),
          new Code(),
          new Italic(),
          new Strike(),
          new Underline(),
          new History(),
          new Table({ resizable: true }),
          new TableHeader(),
          new TableCell(),
          new TableRow(),
        ],
        onBlur: ({ event, state }) => {
          this.options.dataSource = this.editor.getHTML()
        },
        content: '',
      })
    }
  },
  computed: {
  },
  methods: {
    save(){
      db.tipTapEditor.saveOptions(this.editorId, this.options, () =>{})
    },
  },
  mounted() {
    db.tipTapEditor.readOptions(this.editorId, options => {
      this.options = options
      this.editor.setContent(options.dataSource)
      if(options.dataSource.length){
        this.isReadOnly = true
      }
    })
  }
}
</script>

<style>
.editor__content{
  padding-top: 15px;
}
.view_mode{
  padding: 15px;
}
.mention {
  font-size: 0.8rem;
  font-weight: bold;
  border-radius: 5px;
  padding: 0.2rem 0.5rem;
  white-space: nowrap;
}
.editor {
  font-size: 1rem;
  line-height: 1.5;
  display: block;
  width: 100%;
  padding: .625rem .75rem;
  transition: all .15s cubic-bezier(.68, -.55, .265, 1.55);
  color: #8898aa;
  border: 1px solid #dee2e6;
  border-radius: .25rem;
  background-color: #fff;
  background-clip: padding-box;
  box-shadow: 0 3px 2px rgba(233, 236, 239, .05);
}
.menubar__button {
  cursor: pointer;
  margin: 0 5px;
  font-size: 12px;
}
.ProseMirror:focus {
  outline: none;
}
.tableWrapper {
  margin: 1em 0;
  overflow-x: auto;
}
.tableWrapper table {
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;
  margin: 0;
  overflow: hidden;
}
.tableWrapper table td, .editor__content table th {
  min-width: 1em;
  border: 2px solid #ddd;
  padding: 3px 5px;
  vertical-align: top;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
}
.tableWrapper td>*, .editor__content table th>* {
  margin-bottom: 0;
}
</style>